import { Component, Input } from '@angular/core';
import { ITasksAttachment } from 'app/interfaces/task.interface';

@Component({
	selector: 'promptuary-task-description',
	templateUrl: './promptuary-task-description.component.html',
	styleUrls: ['./promptuary-task-description.component.scss'],
})
export class PromptuaryTaskDescription {
	constructor() {}

	@Input() description: string;
	@Input() links: ITasksAttachment[];

	public preventAccordionToggle(event: Event): void {
		event.stopPropagation();
	}
}
